import React, { useEffect, useState } from 'react'
import { containerAPI } from '@hpanel/web-common/api/client'

const TAIL_OPTIONS = [50, 200, 500, 2000]

export const LogsPanel: React.FC<{ containerId: number }> = ({ containerId }) => {
  const [tail, setTail] = useState(200)
  const [logs, setLogs] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchLogs = async () => {
    setLoading(true)
    setError(null)
    try {
      const r = await containerAPI.logs(containerId, tail)
      setLogs(r.logs)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to read logs')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchLogs() }, [containerId, tail])

  const download = () => {
    const blob = new Blob([logs], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `container-${containerId}-logs.txt`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div data-testid="logs-panel" className="space-y-2">
      <div className="flex gap-2 items-center">
        <label>Tail:&nbsp;
          <select data-testid="tail-selector" value={tail} onChange={e => setTail(Number(e.target.value))} className="border rounded px-2 py-1">
            {TAIL_OPTIONS.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
        <button data-testid="logs-refresh" onClick={fetchLogs} disabled={loading} className="px-3 py-1 border rounded">
          {loading ? 'Loading…' : 'Refresh'}
        </button>
        <button data-testid="logs-download" onClick={download} disabled={!logs} className="px-3 py-1 border rounded">
          Download
        </button>
      </div>

      {error && <div data-testid="logs-error" className="text-red-700">{error}</div>}

      <pre data-testid="logs-output" className="bg-gray-900 text-gray-100 font-mono text-xs p-3 rounded overflow-auto max-h-[60vh] whitespace-pre-wrap">
        {logs || (loading ? '' : '(no output)')}
      </pre>
    </div>
  )
}
